<template>
  <div class="bookend-element">
    <ValidationObserver tag="div" ref="observer">
      <form novalidate class="form">
        <FormRow label="Titolo" name="Titolo bookend" rules="required">
          <v-input type="text" v-model="model.title" />
        </FormRow>

        <FormRow label="Link" name="Link bookend" rules="required">
          <v-input type="text" v-model="model.url" />
        </FormRow>

        <FormRow
          label="Immagine"
          legend="(formato quadrato consigliato 400x400 px)"
          name="Immagine bookend"
          rules="required"
        >
          <v-image-input
            v-model="model.src"
            :imageWidth="value.width"
            :imageHeight="value.height"
            :podcastId="podcastId"
          />
        </FormRow>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationObserver,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    podcastId: {
      type: String,
      required: true,
    },
    updateLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      model: {
        ...this.value,
      },
    }
  },

  watch: {
    model: {
      deep: true,
      handler() {
        this.$emit('input', { ...this.model })
      },
    },
  },

  mounted() {
    this.unwatchValidation = this.$watch(
      '$refs.observer.flags.valid',
      valid => {
        this.$emit('valid', valid)
      },
      {
        immediate: true,
      },
    )
  },

  beforeDestroy() {
    this.$unwatchValidation && this.$unwatchValidation()
  },
}
</script>

<style lang="scss" scoped></style>
